export * from './remove-props-from-object/remove-props-from-object';
